import React, { useEffect } from "react";
import DefaultLayout from "../layout/DefaultLayout";
import { useSelector } from "react-redux";
import { userDetailsSelector } from "../../rdxsga/redux/slices/userSlice";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { APP_URLS, USER_ROLES } from "../../config";

function reqAuthLayout(Component, accessLevel = []) {
  function HocLayoutAuth(props) {
    const user = useSelector(userDetailsSelector);
    const navigate = useNavigate();
    const { pathname } = useLocation();


    const isAuthorized = (user?.user?.role === USER_ROLES.CUSTOMER_SERVICE && accessLevel.includes(USER_ROLES.ASSOCIATE)) || [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, ...accessLevel].includes(user?.user?.role);

    // const getUsersMenu = () => {

    //     if (user?.user?.role === USER_ROLES.SUPER_ADMIN) return SUPER_ADMIN_MENU;
    //     else if (user?.user?.role === USER_ROLES.ADMIN) return ADMIN_MENU;
    //     else if (user?.user?.role === USER_ROLES.ASSOCIATE) return ASSOCIATE_MENU;
    //     else if (user?.user?.role === USER_ROLES.TEAM_LEAD) return TEAM_LEAD_MENU;
    //     else if (user?.user?.role === USER_ROLES.HR) return HR_MENU

    //     return []
    //   }

    //   const flattenMenuPaths = (menu) => {
    //     const paths = [];
    //     menu.forEach(item => {
    //         if (item.path) {
    //             paths.push(item.path);
    //         }
    //         if (item.submenu) {
    //             item.submenu.forEach(subItem => {
    //                 if (subItem.path) {
    //                     paths.push(subItem.path);
    //                 }
    //             });
    //         }
    //     });
    //     return paths;
    // };

    // useEffect(() => {
    //     if(!isAdmin)
    //         {

    //            if (!isAuthorized &&  user.isAuthenticated ) {
    //                navigate(APP_URLS.DASHBOARD);
    //            }

    //         }
    // }, [ user]);

    return user.isAuthenticated ? (
      isAuthorized ? (
        <DefaultLayout>
          <Component {...props} />
        </DefaultLayout>
      ) : (
        <Navigate to={APP_URLS.DASHBOARD} />
      )
    ) : (
      <Navigate to={APP_URLS.LOGIN} />
    );
  }
  return <HocLayoutAuth />;
}

export default reqAuthLayout;
